/**
 * Configuración de colecciones Firestore - Faki Pizzas
 *
 * Estructura según backup_estructura_2026-03-03.json
 *
 * Reglas:
 * - supplies: hasRole(['admin', 'gestor'])
 * - recipes: hasRole(['admin', 'gestor'])
 * - products: hasRole(['admin', 'gestor'])
 * - orders: read público, filtrado por status y paid
 */

export const COLLECTIONS = {
  /** Insumos - supplies: name, costoUnitario, unit, classification, stockActual, stockMinimo */
  SUPPLIES: 'supplies',
  /** Recetas - recipes: productId, ingredients: [{supplyId, quantity}] */
  RECIPES: 'recipes',
  /** Productos del menú - products: name, priceBase, presentation, category */
  PRODUCTS: 'products',
  /** Pedidos - orders: items, customer, status, paid, totalEstimado */
  ORDERS: 'orders',
  /** Movimientos de stock - movements: supplyId, quantity, type, reason */
  MOVEMENTS: 'movements',
  /** Configuración del negocio - config: businessName, horarios, phone, etc */
  CONFIG: 'config',
  /** Banners del catálogo - banners: title, description, imageUrl, order, active, startDate, endDate, link */
  BANNERS: 'banners'
};

/** Estados de pedido que se consideran "confirmados y pagados" */
export const ORDER_STATUS_CONFIRMED = ['CONFIRMADO', 'ENTREGADO'];
